<fui-command-pop [popped]="toggled" (popped$)="popped($event)"
                 [parentHorizontalAlignment]="popAlignment" [horizontalOffset]="icon ? 6: 0">
    <ng-content></ng-content>
</fui-command-pop>

<fui-pop-button *ngIf="!icon" [title]="title" [toggled]="toggled">
    <fui-mark-toggle *ngIf="hasCommands" [toggled]="toggled">
        <fui-icon [icon]="'chevron-down'" [height]="6" [width]="12"></fui-icon>
    </fui-mark-toggle>
</fui-pop-button>

<fui-action *ngIf="icon" [attr.title]="title">
    <fui-icon [icon]="icon" [height]="iconSize" [width]="iconSize"></fui-icon>
</fui-action>
